import { useEffect, useRef, useState } from "react";
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { storeIdAction } from "../../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  salesDeliveryEditAction,
  salesDeliveryReceiptCreateAction,
} from "../../../redux/actions/sales-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import SalesPurchaseNavbar from "../sales-purchase-navbar";
import SalesPurchaseFooter from "../sales-purchase-footer";
import SalesItemsSection from "../sales-items-sec";
import SalesBatchesPanel from "../sales-batches-panel";
import LoadingOverlay from "../../helper-components/overlay-loading";

const CreateEditViewSalesDelivery = ({
  isClone = false,
  orderDetail = [],
  vendorDetails = [],
  disabled = false,
  page = "",
  type = "",
  standAlone = false,
  payto,
  shipto,
  itemData,
  pageType,
  clickedplus,
  auto = false,
  isNotViewOnly = true,
}) => {
  console.log(disabled, "fgdgdfgfdgdfgfdgdfgdg");
  console.log("vendorDetails", vendorDetails);
  // console.log("payto", vendorDetails[0].sott_pay_to_address);
  // console.log("shipto", vendorDetails[0].sott_ship_to_address);

  const [heading, setHeading] = useState([]);
  const searchRef = useRef(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [tcsTdsAmount, setTcsTdsAmount] = useState("");
  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const initialData = {
    sl_no: 1,
    item_code: "",
    item_generic_name: "",
    item_name: "",
    item_hsn: "",
    item_manufacturer_name: "",
    item_uom: "",
    item_to_be_delivered: 0,
    quantity: 0,
    item_free_quantity: 0,
    item_batches: [],
    item_discount_amount: 0.0,
    item_total_tax_percentage: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    instock: true,
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_uom_id: "",
    item_manufacturer_id: "",
    // base_quantity: 0,
    pot_id: null,
    pos_id: null,
    base_quantity: 1,
  };

  useEffect(() => {}, [vendorDetails]);

  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    cmr_phone_number: vendorDetails?.[0]?.cmr_phone_number ?? "",
    remarks: vendorDetails?.[0]?.remarks ?? "",
    // customer_invoice_number: vendorDetails?.[0]?.customer_invoice_number ?? null,
    ...(vendorDetails?.[0]?.sodtt_id
      ? { sodtt_id: vendorDetails?.[0]?.sodtt_id }
      : {}),
    sodtt_order_date: vendorDetails?.[0]?.sodtt_order_date
      ? moment(vendorDetails?.[0]?.sodtt_order_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sodtt_document_date: vendorDetails?.[0]?.sodtt_document_date
      ? moment(vendorDetails?.[0]?.sodtt_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sodtt_delivery_date: vendorDetails?.[0]?.sodtt_delivery_date
      ? moment(vendorDetails?.[0]?.sodtt_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    // pot_id: vendorDetails?.[0]?.pot_id ?? null,
    // pos_id: vendorDetails?.[0]?.pos_id ?? null,
    pot_id: itemData?.[0]?.pot_id ?? null,
    pos_id: itemData?.[0]?.pos_id ?? null,
    cmr_tcs: "",
    cmr_tds: "",
    sodtt_sub_total: isClone
      ? 0
      : vendorDetails?.[0]?.sodtt_sub_total || "0.00",
    sodtt_total_discount: isClone
      ? 0
      : vendorDetails?.[0]?.sodtt_total_discount ?? 0,
    sodtt_total_gst: isClone
      ? 0
      : vendorDetails?.[0]?.sodtt_total_gst || "0.00",
    sodtt_round_off_value: vendorDetails?.[0]?.sodtt_round_off_value || "0.00",
    sodtt_total_amount: isClone
      ? 0
      : vendorDetails?.[0]?.sodtt_total_amount || "0.00",
    sodtt_tcs_or_tds_percentage_id:
      vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
    sodtt_tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage ?? 0,
    sodtt_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
    sodtt_tcs_or_tds_amount: vendorDetails?.[0]?.tcs_or_tds_amount ?? 0,
    sodtt_order_status: vendorDetails?.[0]?.sodtt_order_status ?? "",
    sodtt_is_invoice_dis_percentage:
      vendorDetails?.[0]?.sodtt_is_invoice_dis_percentage ?? true,
    sodtt_invoice_discount: vendorDetails?.[0]?.sodtt_invoice_discount ?? 0,
    sodtt_invoice_discount_percentage:
      vendorDetails?.[0]?.sodtt_invoice_discount_percentage ?? 0,
    sodtt_pay_to_address: payto, //new
    sodtt_ship_to_address: shipto, //new
    header_dis_per: "",
    header_inv_dis_per: vendorDetails?.[0]?.sodtt_is_invoice_dis_percentage
      ? vendorDetails?.[0]?.sodtt_invoice_discount_percentage
      : vendorDetails?.[0]?.sodtt_invoice_discount,
    data: [
      ...orderDetail?.map((item, index) => ({
        sl_no: index + 1,
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,
        item_manufacturer_name: item?.item_manufacturer_name,
        item_uom: item?.item_uom ?? "--",
        item_to_be_delivered: item?.item_to_be_delivered,
        quantity: type === "sales" ? 0 : item?.item_quantity ?? 0,
        item_free_quantity: parseInt(item?.item_free_quantity ?? 0) ?? 0,
        item_batches: isClone
          ? []
          : item?.itemBatchData?.map((batch) => ({
              item_batch_number: batch?.item_batch_number ?? 0,
              item_batch_quantity: parseInt(batch?.item_batch_quantity) || 0,
              item_batch_free_quantity:
                parseInt(batch?.item_batch_free_quantity) || 0,
              item_batch_sales_rate:
                parseFloat(batch?.item_batch_sales_rate) || 0,
              item_batch_total_base_sales_rate:
                parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
              item_batch_discount_percentage:
                parseFloat(batch?.item_batch_discount_percentage) || 0,
              item_batch_discount_amount:
                parseFloat(batch?.item_batch_discount_amount) || 0,
              item_batch_discounted_sales_rate:
                parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
              item_batch_tax_percentage:
                parseFloat(batch?.item_batch_tax_percentage) || 0,
              item_batch_tax_amount:
                parseFloat(batch?.item_batch_tax_amount) || 0,
              item_batch_final_sales_rate:
                parseFloat(batch?.item_batch_final_sales_rate) || 0,
              item_batch_total_sales_rate:
                parseFloat(batch?.item_batch_total_sales_rate) || 0,
              item_batch_sgst:
                parseFloat(batch?.item_batch_tax_amount) / 2 || 0,
              item_batch_cgst:
                parseFloat(batch?.item_batch_tax_amount) / 2 || 0,
              item_batch_unit_price:
                parseFloat(batch?.item_batch_unit_price) || 0,
              item_exp_date: batch?.item_exp_date
                ? moment(batch?.item_exp_date).format("YYYY-MM-DD")
                : "1970-01-01", // Default to a date if not provided
              item_id: batch?.item_id ?? 0,
              from_bin_location: batch?.from_bin_location ?? "",
              from_bin_id: batch?.from_bin_id ?? 0,
              item_batch_avail_quantity:
                parseInt(batch?.item_batch_quantity) ?? 0,
            })),
        item_discount_amount:
          type === "sales" || isClone ? 0 : item?.item_discount_amount,
        item_total_tax_percentage:
          type === "sales" || isClone ? 0 : item?.item_total_tax_percentage,
        item_tax_amount:
          type === "sales" || isClone ? 0 : item?.item_tax_amount ?? 0,
        item_total_amount:
          type === "sales" || isClone ? 0 : item?.item_total_amount,
        item_id: item?.item_id,
        sott_id: item?.sott_id ?? null,
        ...(item?.srt_id && type === "return"
          ? { srt_id: item?.srt_id }
          : { srt_id: null }),
        instock: true,
        item_gst: type === "sales" ? 0 : item?.item_gst,
        item_cgst: type === "sales" ? 0 : item?.item_cgst,
        item_sgst: type === "sales" ? 0 : item?.item_sgst,
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
              base_quantity: uom?.base_quantity ?? 1,
            }))
          : [],
        item_uom_id: item?.item_uom_id ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? null,
        base_quantity: item?.base_quantity ?? 1,
      })),
      initialData,
    ],
  };
  const [initialValue, setInitialValue] = useState(initialFormValues);
  const [reload, setReload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code number is required"),
    cmr_name: Yup.object().required("Customer name is required"),
  });
  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const salesdata = parsed.find((obj) => obj?.sales_delivery_create);
      if (salesdata?.sales_delivery_create) {
        setHeading(salesdata.sales_delivery_create);
      }
    }
  }, []);
  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => {};

  const handleSubmit = (values, actions) => {
    console.log(values, "fggdfgdfgdgdfgdfgdfgfdgdg");
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    // page === "edit" &&
    //   values?.submittedButton !== "draft" &&
    //   values?.sodtt_order_status !== "draft"
    if(!values?.sodtt_pay_to_address){
      errorToast("Please verify and save the address");
          return;
    }
    if(!values?.sodtt_ship_to_address){
      errorToast("Please verify and save the address");
          return;
    }
    if (
      page === "edit"
    ) {
      setButtonLoading(true);
      const data = {
        orderData: {
          is_draft_order: values.submittedButton === "draft",
          store_id: storeId,
          ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
          sodtt_total_gst: values?.sodtt_total_gst,
          sodtt_total_discount: values?.sodtt_total_discount,
          sodtt_payment_status: "paid",
          sodtt_transaction_id: "",
          sodtt_billing_address: "",
          sodtt_total_amount: values?.sodtt_total_amount,
          sodtt_sub_total: values?.sodtt_sub_total,
          cmr_code: values?.cmr_code?.label,
          cmr_id: values?.cmr_id,
          cmr_name: values?.cmr_name?.label,
          remarks: values?.remarks,
          sodtt_order_date: values?.sodtt_order_date,
          sodtt_document_date: values?.sodtt_document_date,
          sodtt_delivery_date: values?.sodtt_delivery_date,
          pot_id: values?.pot_id ?? null,
          pos_id: values?.pos_id ?? null,
          sodtt_round_off_value: values?.sodtt_round_off_value,
          sodtt_tcs_or_tds_percentage_id:
            values?.sodtt_tcs_or_tds_percentage_id ?? "",
          sodtt_tcs_or_tds_percentage:
            values?.sodtt_tcs_or_tds_percentage ?? 0,
          sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
          sodtt_tcs_or_tds_amount:
            values?.sodtt_tcs_or_tds_amount ?? 0,
          sodtt_is_invoice_dis_percentage:
            values?.sodtt_is_invoice_dis_percentage,
          sodtt_invoice_discount:
            Number(values?.sodtt_invoice_discount) ?? 0,
          sodtt_invoice_discount_percentage:
            Number(values?.sodtt_invoice_discount_percentage) ?? 0,
          sodtt_pay_to_address: values?.sodtt_pay_to_address || null,
          sodtt_ship_to_address: values?.sodtt_ship_to_address || null,
        },

        itemData: values?.data
          ?.slice(0, -1)
          .map((item) => ({
            item_code: item?.item_code,
            item_generic_name: item?.item_generic_name,
            item_name: item?.item_name,
            item_hsn: item?.item_hsn,
            item_quantity: parseInt(item?.quantity),
            item_delivered_quantity: parseInt(item?.quantity),
            item_free_quantity: item?.item_batches?.reduce(
              (sum, batch) =>
                sum + (parseInt(batch?.item_batch_free_quantity, 10) || 0),
              0
            ),
            item_batch_number: item?.item_batch_number,
            item_schedule: item?.item_schedule,
            item_discount_amount: parseFloat(item?.item_discount_amount),
            item_total_tax_percentage: item?.item_total_tax_percentage,
            item_tax_amount: parseFloat(item?.item_tax_amount),
            item_total_amount: item?.item_total_amount,
            item_id: item?.item_id,
            sott_id: item?.sott_id ?? null,
            srt_id: item?.srt_id ?? null,
            item_gst: parseFloat(item?.item_gst),
            item_sgst: parseFloat(item?.item_sgst),
            item_cgst: parseFloat(item?.item_cgst),
            item_uom_id: item?.item_uom_id ?? "",
            item_uom: item?.item_uom ?? "",
            item_manufacturer_id: item?.item_manufacturer_id ?? "",
            item_manufacturer_name: item?.item_manufacturer_name ?? "",
            pot_id: item?.pot_id ?? null,
            pos_id: item?.pos_id ?? null,
          })),

        itemBatchData: values?.data
          ?.slice(0, -1)
          .flatMap((item) =>
            item?.item_batches?.map((batch) => ({
              item_batch_number: batch?.item_batch_number,
              item_batch_quantity: parseInt(batch?.item_batch_quantity),
              item_batch_free_quantity: parseInt(batch?.item_batch_free_quantity),
              item_batch_sales_rate: parseFloat(batch?.item_batch_sales_rate),
              item_batch_total_base_sales_rate:
                parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
              item_batch_discount_percentage:
                batch?.item_batch_discount_percentage,
              item_batch_discount_amount: parseFloat(
                batch?.item_batch_discount_amount
              ),
              item_batch_discounted_sales_rate:
                parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
              item_batch_tax_percentage: batch?.item_batch_tax_percentage,
              item_batch_tax_amount: parseFloat(batch?.item_batch_tax_amount),
              item_batch_final_sales_rate: parseFloat(
                batch?.item_batch_final_sales_rate
              ),
              item_batch_total_sales_rate: parseFloat(
                batch?.item_batch_total_sales_rate
              ),
              item_batch_unit_price: parseFloat(
                batch?.item_batch_unit_price
              ),
              item_exp_date: batch?.item_exp_date,
              item_id: batch?.item_id,
              from_bin_location: batch?.from_bin_location,
              from_bin_id: batch?.from_bin_id,
              item_uom: item?.item_uom ?? "",
              item_uom_id: item?.item_uom_id ?? "",
            })) || []
          ),
      };

      dispatch(
        salesDeliveryEditAction(
          data,
          onSuccessOrder,
          onErrorOrder
        )
      );
      // dispatch(
      //   salesDeliveryEditAction(
      //     {
      //       orderData: {
      //         is_draft_order:
      //           values.submittedButton === "draft" ? true : false,
      //         store_id: storeId,
      //         ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
      //         sodtt_total_gst: values?.sodtt_total_gst,
      //         sodtt_total_discount: values?.sodtt_total_discount,
      //         sodtt_payment_status: "paid",
      //         sodtt_transaction_id: "",
      //         sodtt_billing_address: "",
      //         sodtt_total_amount: values?.sodtt_total_amount,
      //         sodtt_sub_total: values?.sodtt_sub_total,
      //         cmr_code: values?.cmr_code?.label,
      //         cmr_id: values?.cmr_id,
      //         cmr_name: values?.cmr_name?.label,
      //         remarks: values?.remarks,
      //         sodtt_order_date: values?.sodtt_order_date,
      //         sodtt_document_date: values?.sodtt_document_date,
      //         sodtt_delivery_date: values?.sodtt_delivery_date,
      //         pot_id: values?.pot_id ?? null,
      //         pos_id: values?.pos_id ?? null,
      //         sodtt_round_off_value: values?.sodtt_round_off_value,
      //         sodtt_tcs_or_tds_percentage_id:
      //           values?.sodtt_tcs_or_tds_percentage_id ?? "",
      //         sodtt_tcs_or_tds_percentage:
      //           values?.sodtt_tcs_or_tds_percentage ?? 0,
      //         sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
      //         sodtt_tcs_or_tds_amount:
      //           values?.sodtt_tcs_or_tds_amount ?? 0,
      //         // customer_invoice_number: values?.customer_invoice_number,
      //         sodtt_is_invoice_dis_percentage:
      //           values?.sodtt_is_invoice_dis_percentage,
      //         sodtt_invoice_discount:
      //           Number(values?.sodtt_invoice_discount) ?? 0,
      //         sodtt_invoice_discount_percentage:
      //           Number(values?.sodtt_invoice_discount_percentage) ?? 0,
      //         sodtt_pay_to_address: values?.sodtt_pay_to_address || null, //new
      //         sodtt_ship_to_address:
      //           values?.sodtt_ship_to_address || null, //new
      //       },
      //       itemData: values?.data?.slice(0, -1).map((item, index) => ({
      //         item_code: item?.item_code,
      //         item_generic_name: item?.item_generic_name,
      //         item_name: item?.item_name,
      //         item_hsn: item?.item_hsn,
      //         item_quantity: parseInt(item?.quantity),
      //         item_delivered_quantity: parseInt(item?.quantity),
      //         item_free_quantity: item?.item_batches?.reduce(
      //           (sum, batch) =>
      //             sum +
      //             (parseInt(batch.item_batch_free_quantity, 10) || 0),
      //           0
      //         ),
      //         item_batch_number: item?.item_batch_number,
      //         item_schedule: item?.item_schedule,
      //         item_discount_amount: parseFloat(
      //           item?.item_discount_amount
      //         ),
      //         item_total_tax_percentage: item?.item_total_tax_percentage,
      //         item_tax_amount: parseFloat(item?.item_tax_amount),
      //         item_total_amount: item?.item_total_amount,
      //         item_id: item?.item_id,
      //         ...(item?.sott_id
      //           ? { sott_id: item?.sott_id }
      //           : { sott_id: null }),
      //         ...(item?.srt_id
      //           ? { srt_id: item?.srt_id }
      //           : { srt_id: null }),
      //         item_gst: parseFloat(item?.item_gst),
      //         item_sgst: parseFloat(item?.item_sgst),
      //         item_cgst: parseFloat(item?.item_cgst),
      //         item_uom_id: item?.item_uom_id ?? "",
      //         item_uom: item?.item_uom ?? "",
      //         item_manufacturer_id: item?.item_manufacturer_id ?? "",
      //         item_manufacturer_name: item?.item_manufacturer_name ?? "",
      //         pot_id: item?.pot_id ?? null,
      //         pos_id: item?.pos_id ?? null,
      //       })),

      //       itemBatchData: values.data
      //         ?.slice(0, -1)
      //         .map((item) => item.item_batches)
      //         .flat()
      //         .map((batch) => ({
      //           item_batch_number: batch?.item_batch_number,
      //           item_batch_quantity: parseInt(batch?.item_batch_quantity),
      //           item_batch_free_quantity: parseInt(
      //             batch?.item_batch_free_quantity
      //           ),
      //           item_batch_sales_rate: parseFloat(
      //             batch?.item_batch_sales_rate
      //           ),
      //           item_batch_total_base_sales_rate:
      //             parseFloat(batch?.item_batch_total_base_sales_rate) ||
      //             0,
      //           item_batch_discount_percentage:
      //             batch?.item_batch_discount_percentage,
      //           item_batch_discount_amount: parseFloat(
      //             batch?.item_batch_discount_amount
      //           ),
      //           item_batch_discounted_sales_rate:
      //             parseFloat(batch?.item_batch_discounted_sales_rate) ||
      //             0,
      //           item_batch_tax_percentage:
      //             batch?.item_batch_tax_percentage,
      //           item_batch_tax_amount: parseFloat(
      //             batch?.item_batch_tax_amount
      //           ),
      //           item_batch_final_sales_rate: parseFloat(
      //             batch?.item_batch_final_sales_rate
      //           ),
      //           item_batch_total_sales_rate: parseFloat(
      //             batch?.item_batch_total_sales_rate
      //           ),
      //           item_batch_unit_price: parseFloat(
      //             batch?.item_batch_unit_price
      //           ),
      //           item_exp_date: batch?.item_exp_date,
      //           item_id: batch?.item_id,
      //           from_bin_location: batch?.from_bin_location,
      //           from_bin_id: batch?.from_bin_id,
      //           item_uom: orderDetail?.[0]?.item_uom,
      //           item_uom_id: orderDetail?.[0]?.item_uom_id,
      //         })),
      //     },
      //     onSuccessOrder,
      //     onErrorOrder
      //   )
      // );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if (values?.data?.length > 1) {
          setButtonLoading(true);
          setTimeout(() => {
            const data = {
              orderData: {
                is_draft_order: values.submittedButton === "draft",
                store_id: storeId,
                ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
                sodtt_total_gst: values?.sodtt_total_gst,
                sodtt_total_discount: values?.sodtt_total_discount,
                sodtt_payment_status: "paid",
                sodtt_transaction_id: "",
                sodtt_billing_address: "",
                sodtt_total_amount: values?.sodtt_total_amount,
                sodtt_sub_total: values?.sodtt_sub_total,
                cmr_code: values?.cmr_code?.label,
                cmr_id: values?.cmr_id,
                cmr_name: values?.cmr_name?.label,
                remarks: values?.remarks,
                sodtt_order_date: values?.sodtt_order_date,
                sodtt_document_date: values?.sodtt_document_date,
                sodtt_delivery_date: values?.sodtt_delivery_date,
                pot_id: values?.pot_id ?? null,
                pos_id: values?.pos_id ?? null,
                sodtt_round_off_value: values?.sodtt_round_off_value,
                sodtt_tcs_or_tds_percentage_id:
                  values?.sodtt_tcs_or_tds_percentage_id ?? "",
                sodtt_tcs_or_tds_percentage:
                  values?.sodtt_tcs_or_tds_percentage ?? 0,
                sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
                sodtt_tcs_or_tds_amount:
                  values?.sodtt_tcs_or_tds_amount ?? 0,
                sodtt_is_invoice_dis_percentage:
                  values?.sodtt_is_invoice_dis_percentage,
                sodtt_invoice_discount:
                  Number(values?.sodtt_invoice_discount) ?? 0,
                sodtt_invoice_discount_percentage:
                  Number(values?.sodtt_invoice_discount_percentage) ?? 0,
                sodtt_pay_to_address: values?.sodtt_pay_to_address || null,
                sodtt_ship_to_address: values?.sodtt_ship_to_address || null,
              },

              itemData: values?.data
                ?.slice(0, -1)
                .map((item) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_quantity: parseInt(item?.quantity),
                  item_delivered_quantity: parseInt(item?.quantity),
                  item_free_quantity: item?.item_batches?.reduce(
                    (sum, batch) =>
                      sum + (parseInt(batch.item_batch_free_quantity, 10) || 0),
                    0
                  ),
                  item_batch_number: item?.item_batch_number,
                  item_schedule: item?.item_schedule,
                  item_discount_amount: parseFloat(item?.item_discount_amount),
                  item_total_tax_percentage: item?.item_total_tax_percentage,
                  item_tax_amount: parseFloat(item?.item_tax_amount),
                  item_total_amount: item?.item_total_amount,
                  item_id: item?.item_id,
                  sott_id: item?.sott_id ?? null,
                  srt_id: item?.srt_id ?? null,
                  item_gst: parseFloat(item?.item_gst),
                  item_sgst: parseFloat(item?.item_sgst),
                  item_cgst: parseFloat(item?.item_cgst),
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  pot_id: item?.pot_id ?? null,
                  pos_id: item?.pos_id ?? null,
                })),

              itemBatchData: values?.data
                ?.slice(0, -1)
                .flatMap((item) =>
                  item.item_batches.map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_batch_quantity: parseInt(batch?.item_batch_quantity),
                    item_batch_free_quantity: parseInt(
                      batch?.item_batch_free_quantity
                    ),
                    item_batch_sales_rate: parseFloat(
                      batch?.item_batch_sales_rate
                    ),
                    item_batch_total_base_sales_rate:
                      parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                    item_batch_discount_percentage:
                      batch?.item_batch_discount_percentage,
                    item_batch_discount_amount: parseFloat(
                      batch?.item_batch_discount_amount
                    ),
                    item_batch_discounted_sales_rate:
                      parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                    item_batch_tax_percentage:
                      batch?.item_batch_tax_percentage,
                    item_batch_tax_amount: parseFloat(
                      batch?.item_batch_tax_amount
                    ),
                    item_batch_final_sales_rate: parseFloat(
                      batch?.item_batch_final_sales_rate
                    ),
                    item_batch_total_sales_rate: parseFloat(
                      batch?.item_batch_total_sales_rate
                    ),
                    item_batch_unit_price: parseFloat(
                      batch?.item_batch_unit_price
                    ),
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    from_bin_id: batch?.from_bin_id,
                    item_uom: item?.item_uom ?? "",
                    item_uom_id: item?.item_uom_id ?? "",
                  }))
                ),
            };

            dispatch(
              salesDeliveryReceiptCreateAction(
                data,
                onSuccessOrder,
                onErrorOrder
              )
            );

            // dispatch(
            //   salesDeliveryReceiptCreateAction(
            //     {
            //       orderData: {
            //         is_draft_order:
            //           values.submittedButton === "draft" ? true : false,
            //         store_id: storeId,
            //         ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
            //         sodtt_total_gst: values?.sodtt_total_gst,
            //         sodtt_total_discount: values?.sodtt_total_discount,
            //         sodtt_payment_status: "paid",
            //         sodtt_transaction_id: "",
            //         sodtt_billing_address: "",
            //         sodtt_total_amount: values?.sodtt_total_amount,
            //         sodtt_sub_total: values?.sodtt_sub_total,
            //         cmr_code: values?.cmr_code?.label,
            //         cmr_id: values?.cmr_id,
            //         cmr_name: values?.cmr_name?.label,
            //         remarks: values?.remarks,
            //         sodtt_order_date: values?.sodtt_order_date,
            //         sodtt_document_date: values?.sodtt_document_date,
            //         sodtt_delivery_date: values?.sodtt_delivery_date,
            //         pot_id: values?.pot_id ?? null,
            //         pos_id: values?.pos_id ?? null,
            //         sodtt_round_off_value: values?.sodtt_round_off_value,
            //         sodtt_tcs_or_tds_percentage_id:
            //           values?.sodtt_tcs_or_tds_percentage_id ?? "",
            //         sodtt_tcs_or_tds_percentage:
            //           values?.sodtt_tcs_or_tds_percentage ?? 0,
            //         sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
            //         sodtt_tcs_or_tds_amount:
            //           values?.sodtt_tcs_or_tds_amount ?? 0,
            //         // customer_invoice_number: values?.customer_invoice_number,
            //         sodtt_is_invoice_dis_percentage:
            //           values?.sodtt_is_invoice_dis_percentage,
            //         sodtt_invoice_discount:
            //           Number(values?.sodtt_invoice_discount) ?? 0,
            //         sodtt_invoice_discount_percentage:
            //           Number(values?.sodtt_invoice_discount_percentage) ?? 0,
            //         sodtt_pay_to_address: values?.sodtt_pay_to_address || null, //new
            //         sodtt_ship_to_address:
            //           values?.sodtt_ship_to_address || null, //new
            //       },
            //       itemData: values?.data?.slice(0, -1).map((item, index) => ({
            //         item_code: item?.item_code,
            //         item_generic_name: item?.item_generic_name,
            //         item_name: item?.item_name,
            //         item_hsn: item?.item_hsn,
            //         item_quantity: parseInt(item?.quantity),
            //         item_delivered_quantity: parseInt(item?.quantity),
            //         item_free_quantity: item?.item_batches?.reduce(
            //           (sum, batch) =>
            //             sum +
            //             (parseInt(batch.item_batch_free_quantity, 10) || 0),
            //           0
            //         ),
            //         item_batch_number: item?.item_batch_number,
            //         item_schedule: item?.item_schedule,
            //         item_discount_amount: parseFloat(
            //           item?.item_discount_amount
            //         ),
            //         item_total_tax_percentage: item?.item_total_tax_percentage,
            //         item_tax_amount: parseFloat(item?.item_tax_amount),
            //         item_total_amount: item?.item_total_amount,
            //         item_id: item?.item_id,
            //         ...(item?.sott_id
            //           ? { sott_id: item?.sott_id }
            //           : { sott_id: null }),
            //         ...(item?.srt_id
            //           ? { srt_id: item?.srt_id }
            //           : { srt_id: null }),
            //         item_gst: parseFloat(item?.item_gst),
            //         item_sgst: parseFloat(item?.item_sgst),
            //         item_cgst: parseFloat(item?.item_cgst),
            //         item_uom_id: item?.item_uom_id ?? "",
            //         item_uom: item?.item_uom ?? "",
            //         item_manufacturer_id: item?.item_manufacturer_id ?? "",
            //         item_manufacturer_name: item?.item_manufacturer_name ?? "",
            //         pot_id: item?.pot_id ?? null,
            //         pos_id: item?.pos_id ?? null,
            //       })),

            //       itemBatchData: values.data
            //         ?.slice(0, -1)
            //         .map((item) => item.item_batches)
            //         .flat()
            //         .map((batch) => ({
            //           item_batch_number: batch?.item_batch_number,
            //           item_batch_quantity: parseInt(batch?.item_batch_quantity),
            //           item_batch_free_quantity: parseInt(
            //             batch?.item_batch_free_quantity
            //           ),
            //           item_batch_sales_rate: parseFloat(
            //             batch?.item_batch_sales_rate
            //           ),
            //           item_batch_total_base_sales_rate:
            //             parseFloat(batch?.item_batch_total_base_sales_rate) ||
            //             0,
            //           item_batch_discount_percentage:
            //             batch?.item_batch_discount_percentage,
            //           item_batch_discount_amount: parseFloat(
            //             batch?.item_batch_discount_amount
            //           ),
            //           item_batch_discounted_sales_rate:
            //             parseFloat(batch?.item_batch_discounted_sales_rate) ||
            //             0,
            //           item_batch_tax_percentage:
            //             batch?.item_batch_tax_percentage,
            //           item_batch_tax_amount: parseFloat(
            //             batch?.item_batch_tax_amount
            //           ),
            //           item_batch_final_sales_rate: parseFloat(
            //             batch?.item_batch_final_sales_rate
            //           ),
            //           item_batch_total_sales_rate: parseFloat(
            //             batch?.item_batch_total_sales_rate
            //           ),
            //           item_batch_unit_price: parseFloat(
            //             batch?.item_batch_unit_price
            //           ),
            //           item_exp_date: batch?.item_exp_date,
            //           item_id: batch?.item_id,
            //           from_bin_location: batch?.from_bin_location,
            //           from_bin_id: batch?.from_bin_id,
            //           item_uom: orderDetail?.[0]?.item_uom,
            //           item_uom_id: orderDetail?.[0]?.item_uom_id,
            //         })),
            //     },
            //     onSuccessOrder,
            //     onErrorOrder
            //   )
            // );
          }, 500);
        }
      }
    }
  };
  const onSuccessOrder = (data) => {
    setButtonLoading(false);

    if (formValues?.submittedButton === "print") {
      handlea4Print(
        data?.data?.orderData?.sodtt_id,
        "sales_delivery",
        dispatch
      );
    }
    navigate("/sales-delivery");
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      cmr_id: "",
      remarks: "",
      sodtt_total_discount: 0,
      sodtt_order_date: null,
      sodtt_document_date: null,
      sodtt_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = (data) => {
    errorToast(data?.data?.message);

    setButtonLoading(false);
  };

  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  const autoDraft = (values) => {
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.sodtt_order_status !== "draft"
    ) {
      setButtonLoading(true);

      dispatch(
        salesDeliveryEditAction(
          {
            is_draft_order: values.submittedButton === "draft" ? true : false,
            only_remarks: true,
            sodtt_id: values?.sodtt_id,
            remarks: values?.remarks,
          },
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if (values?.data?.length > 1) {
          setButtonLoading(true);
          setTimeout(() => {
            dispatch(
              salesDeliveryReceiptCreateAction(
                {
                  orderData: {
                    is_draft_order: true,
                    store_id: storeId,
                    ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
                    sodtt_total_gst: values?.sodtt_total_gst,
                    sodtt_total_discount: values?.sodtt_total_discount,
                    sodtt_payment_status: "paid",
                    sodtt_transaction_id: "",
                    sodtt_billing_address: "",
                    sodtt_total_amount: values?.sodtt_total_amount,
                    sodtt_sub_total: values?.sodtt_sub_total,
                    cmr_code: values?.cmr_code?.label,
                    cmr_id: values?.cmr_id,
                    cmr_name: values?.cmr_name?.label,
                    remarks: values?.remarks,
                    sodtt_order_date: values?.sodtt_order_date,
                    sodtt_document_date: values?.sodtt_document_date,
                    sodtt_delivery_date: values?.sodtt_delivery_date,
                    pot_id: values?.pot_id ?? null,
                    pos_id: values?.pos_id ?? null,
                    sodtt_round_off_value: values?.sodtt_round_off_value,
                    sodtt_tcs_or_tds_percentage_id:
                      values?.sodtt_tcs_or_tds_percentage_id ?? "",
                    sodtt_tcs_or_tds_percentage:
                      values?.sodtt_tcs_or_tds_percentage ?? 0,
                    sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
                    sodtt_tcs_or_tds_amount:
                      values?.sodtt_tcs_or_tds_amount ?? 0,
                    // customer_invoice_number: values?.customer_invoice_number,
                    sodtt_is_invoice_dis_percentage:
                      values?.sodtt_is_invoice_dis_percentage,
                    sodtt_invoice_discount:
                      Number(values?.sodtt_invoice_discount) ?? 0,
                    sodtt_invoice_discount_percentage:
                      Number(values?.sodtt_invoice_discount_percentage) ?? 0,
                    sodtt_pay_to_address: values?.sodtt_pay_to_address || null, //new
                    sodtt_ship_to_address:
                      values?.sodtt_ship_to_address || null, //new
                  },
                  itemData: values?.data?.slice(0, -1).map((item, index) => ({
                    item_code: item?.item_code,
                    item_generic_name: item?.item_generic_name,
                    item_name: item?.item_name,
                    item_hsn: item?.item_hsn,
                    item_quantity: parseInt(item?.quantity),
                    item_delivered_quantity: parseInt(item?.quantity),
                    item_free_quantity: item?.item_batches?.reduce(
                      (sum, batch) =>
                        sum +
                        (parseInt(batch.item_batch_free_quantity, 10) || 0),
                      0
                    ),
                    item_batch_number: item?.item_batch_number,
                    item_schedule: item?.item_schedule,
                    item_discount_amount: parseFloat(
                      item?.item_discount_amount
                    ),
                    item_total_tax_percentage: item?.item_total_tax_percentage,
                    item_tax_amount: parseFloat(item?.item_tax_amount),
                    item_total_amount: item?.item_total_amount,
                    item_id: item?.item_id,
                    ...(item?.sott_id
                      ? { sott_id: item?.sott_id }
                      : { sott_id: null }),
                    ...(item?.srt_id
                      ? { srt_id: item?.srt_id }
                      : { srt_id: null }),
                    item_gst: parseFloat(item?.item_gst),
                    item_sgst: parseFloat(item?.item_sgst),
                    item_cgst: parseFloat(item?.item_cgst),
                    item_uom_id: item?.item_uom_id ?? "",
                    item_uom: item?.item_uom ?? "",
                    item_manufacturer_id: item?.item_manufacturer_id ?? "",
                    item_manufacturer_name: item?.item_manufacturer_name ?? "",
                    pot_id: item?.pot_id ?? null,
                    pos_id: item?.pos_id ?? null,
                  })),

                  itemBatchData: values.data
                    ?.slice(0, -1)
                    .map((item) => item.item_batches)
                    .flat()
                    .map((batch) => ({
                      item_batch_number: batch?.item_batch_number,
                      item_batch_quantity: parseInt(batch?.item_batch_quantity),
                      item_batch_free_quantity: parseInt(
                        batch?.item_batch_free_quantity
                      ),
                      item_batch_sales_rate: parseFloat(
                        batch?.item_batch_sales_rate
                      ),
                      item_batch_total_base_sales_rate:
                        parseFloat(batch?.item_batch_total_base_sales_rate) ||
                        0,
                      item_batch_discount_percentage:
                        batch?.item_batch_discount_percentage,
                      item_batch_discount_amount: parseFloat(
                        batch?.item_batch_discount_amount
                      ),
                      item_batch_discounted_sales_rate:
                        parseFloat(batch?.item_batch_discounted_sales_rate) ||
                        0,
                      item_batch_tax_percentage:
                        batch?.item_batch_tax_percentage,
                      item_batch_tax_amount: parseFloat(
                        batch?.item_batch_tax_amount
                      ),
                      item_batch_final_sales_rate: parseFloat(
                        batch?.item_batch_final_sales_rate
                      ),
                      item_batch_total_sales_rate: parseFloat(
                        batch?.item_batch_total_sales_rate
                      ),
                      item_batch_unit_price: parseFloat(
                        batch?.item_batch_unit_price
                      ),
                      item_exp_date: batch?.item_exp_date,
                      item_id: batch?.item_id,
                      from_bin_location: batch?.from_bin_location,
                      from_bin_id: batch?.from_bin_id,
                      item_uom: orderDetail?.[0]?.item_uom,
                      item_uom_id: orderDetail?.[0]?.item_uom_id,
                    })),
                },
                (data) => {
                  successToast(data?.message);
                  // setLoading(true);
                  setTimeout(() => {
                    // setLoading(false);
                  }, 50);
                  navigate(
                    `/edit-customer-admin/${values?.cmr_id}?backto=/edit-delivery/${data?.data?.orderData?.sodtt_id}?new`,
                    {
                      state: { tab: "Address" },
                    }
                  );
                },
                (data) => {
                  errorToast(data?.data?.message);
                }
              )
            );
          }, 500);
        }
      }
    }
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        handleSubmit(values, actions); // Pass values and actions if needed
        actions.setSubmitting(false); // Notify Formik that submission is done
      }}
    >
      {({ values }) => {
        // setFormValues(values);
        console.log(values, "lll");

        return (
          <Form className="h-full">
            {console.log("rrr", values)}
            {/* <UpdateShipto shipto={shipto} /> */}
            <UpdatePayto vendorDetails={vendorDetails} />

            <div
              style={{
                height: `calc(100% - 8rem)`,
              }}
              className="mx-5 flex flex-col h-full "
            >
              <SalesBatchesPanel
                searchRef={searchRef}
                open={addbatch}
                disabled={disabled}
                setItemId={setItemId}
                itemId={itemId}
                setOpen={setAddbatch}
                itemValues={values}
                prefix="sodtt"
              />
              <SalesPurchaseNavbar
                isClone={isClone}
                autoDraft={autoDraft}
                clickedplus={clickedplus}
                pageType={pageType}
                pageName="sales delivery"
                page={page}
                isCusInvNumRequired={false}
                section="sales"
                name="sodtt"
                disabled={disabled}
                searchRef={searchRef}
              />
              <SalesItemsSection
                isClone={isClone}
                auto={auto}
                heading={heading}
                standAlone={standAlone}
                disName="sodtt_total_discount"
                type={type}
                disabled={disabled}
                addBatchFn={(id) => {
                  setAddbatch(true);
                  setItemId(id);
                }}
                searchRef={searchRef}
                initialData={initialData}
                prefixName="sodtt"
                isNotViewOnly={isNotViewOnly}
                clickedplus={clickedplus}
              />
            </div>
            <SalesPurchaseFooter
              modules="sales"
              transaction="Delivery Note"
              transaction_type="sales_delivery"
              buttonLoading={buttonLoading}
              name="sodtt_total_discount"
              page={page}
              disabled={disabled}
              EditFn={() =>
                navigate(`/edit-delivery/${vendorDetails?.[0]?.sodtt_id}`)
              }
              prefixName="sodtt"
              tcsTdsAmount={tcsTdsAmount}
              setTcsTdsAmount={setTcsTdsAmount}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEditViewSalesDelivery;

function UpdateShipto({ shipto }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    // console.log("///", shipto);
    if (shipto) {
      setFieldValue("sodtt_ship_to_address", shipto);
    }
  }, [shipto]);

  return null;
}

function UpdatePayto({ vendorDetails }) {
  const { values, setFieldValue } = useFormikContext();
  console.log("///", vendorDetails);

  useEffect(() => {
    // setFieldValue("sodtt_pay_to_address", vendorDetails.sott_pay_to_address);
    // setFieldValue("sodtt_ship_to_address", vendorDetails.sott_ship_to_address);
  }, [vendorDetails]);

  return null;
}
